import { defineComponent as V, computed as i, ref as S, createElementBlock as d, createCommentVNode as T, openBlock as l, createElementVNode as s, createVNode as g, unref as n, withCtx as x, createTextVNode as k, toDisplayString as f, normalizeClass as v, Fragment as j, renderList as z, createBlock as O } from "vue";
import { RevButton as q } from "@ds/components/Button";
import { RevButtonBase as G } from "@ds/components/ButtonBase";
import { RevButtonIcon as h } from "@ds/components/ButtonIcon";
import H from "../../icons/generated/IconChevronDown.vue2.js";
import J from "../../icons/generated/IconChevronLeft.vue2.js";
import K from "../../icons/generated/IconChevronRight.vue2.js";
import { tw as r } from "../../utils/tailwind.js";
import { ELLIPSIS as y } from "./Pagination.constant.js";
import { getPagesToDisplay as M } from "./Pagination.helpers.js";
const Q = ["aria-label"], W = { class: "flex list-none gap-8" }, X = { class: "relative" }, Y = ["aria-hidden"], ue = /* @__PURE__ */ V({
  name: "RevPagination",
  __name: "Pagination",
  props: {
    navigationAriaLabel: {},
    previousAriaLabel: {},
    nextAriaLabel: {},
    currentPage: {},
    currentPageLabel: {},
    pageCount: {},
    pageAriaLabel: {},
    pageURL: { type: Function, default: void 0 }
  },
  emits: ["click"],
  setup(a, { emit: C }) {
    const e = a, w = C, p = r`body-1-bold flex h-40 min-w-full items-center justify-center md:min-w-40 md:px-4`, R = [
      p,
      r`text-static-default-mid`
    ], b = [
      p,
      r`focus-visible-outline-default-hi motion-safe:transition motion-safe:duration-200 motion-safe:ease-in`,
      r`group-first:rounded-t-sm group-last:rounded-b-sm md:rounded-sm`
    ], A = [
      b,
      r`bg-action-default-low text-action-default-hi hover:bg-action-default-low-hover`
    ], B = [
      b,
      r`bg-action-default-low-pressed text-onaction-default-low-pressed hover:bg-action-default-low-hoverpressed`
    ], P = i(() => e.currentPage > 1), L = i(() => e.currentPage < e.pageCount), F = i(() => {
      if (e.pageURL && P.value)
        return e.pageURL(e.currentPage - 1);
    }), U = i(() => {
      if (e.pageURL && L.value)
        return e.pageURL(e.currentPage + 1);
    }), $ = i(() => e.pageCount > 1), E = i(() => M(e.currentPage, e.pageCount)), D = (u) => typeof u == "string", o = S(!1);
    function I() {
      o.value = !o.value;
    }
    function m(u) {
      o.value = !1, w("click", { page: u });
    }
    return (u, c) => $.value ? (l(), d("nav", {
      key: 0,
      "aria-label": a.navigationAriaLabel,
      class: "flex justify-center"
    }, [
      s("ul", W, [
        s("li", null, [
          g(n(h), {
            "alternative-text": a.previousAriaLabel,
            class: "mx-4",
            disabled: !P.value,
            icon: n(J),
            to: F.value,
            variant: "secondary",
            onClick: c[0] || (c[0] = (t) => m(a.currentPage - 1))
          }, null, 8, ["alternative-text", "disabled", "icon", "to"])
        ]),
        s("li", X, [
          g(n(q), {
            "aria-controls": "pagination-pages",
            "aria-expanded": o.value,
            "aria-haspopup": "true",
            class: "mt-4 md:hidden",
            icon: n(H),
            size: "small",
            type: "button",
            variant: "secondary",
            onClick: I
          }, {
            default: x(() => [
              k(f(a.currentPageLabel), 1)
            ]),
            _: 1
          }, 8, ["aria-expanded", "icon"]),
          s("ul", {
            id: "pagination-pages",
            class: v(["bg-overlap-default-low shadow-long rounded-sm absolute mt-4 w-full list-none md:relative md:mt-0 md:flex md:gap-8 md:bg-transparent md:shadow-none", { hidden: !o.value }])
          }, [
            (l(!0), d(j, null, z(E.value, (t, N) => (l(), d("li", {
              key: N,
              "aria-hidden": t === n(y),
              class: "border-static-default-low group border-b first:rounded-t-sm last:rounded-b-sm last:border-none md:border-none"
            }, [
              D(t) ? (l(), d("span", {
                key: 0,
                class: v(R)
              }, f(n(y)), 1)) : (l(), O(n(G), {
                key: 1,
                "aria-current": t === a.currentPage ? "page" : void 0,
                "aria-label": a.pageAriaLabel(t),
                class: v(
                  t === a.currentPage && !o.value ? B : A
                ),
                to: a.pageURL?.(t),
                type: "button",
                variant: "primary",
                onClick: (Z) => m(t)
              }, {
                default: x(() => [
                  k(f(t), 1)
                ]),
                _: 2
              }, 1032, ["aria-current", "aria-label", "class", "to", "onClick"]))
            ], 8, Y))), 128))
          ], 2)
        ]),
        s("li", null, [
          g(n(h), {
            "alternative-text": a.nextAriaLabel,
            class: "mx-4",
            disabled: !L.value,
            icon: n(K),
            to: U.value,
            variant: "secondary",
            onClick: c[1] || (c[1] = (t) => m(a.currentPage + 1))
          }, null, 8, ["alternative-text", "disabled", "icon", "to"])
        ])
      ])
    ], 8, Q)) : T("", !0);
  }
});
export {
  ue as default
};
